import { render } from "./AssignMultipleAddonsModal.vue?vue&type=template&id=3f3394a4&ts=true"
import script from "./AssignMultipleAddonsModal.vue?vue&type=script&lang=ts"
export * from "./AssignMultipleAddonsModal.vue?vue&type=script&lang=ts"

import "./AssignMultipleAddonsModal.vue?vue&type=style&index=0&id=3f3394a4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__